import React from 'react';

import moment from 'moment';

import { FilterItem } from 'components/FiltersBottomSheet';
import Range from 'components/Range';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { DepartureTime } from 'models/flightFilter';

import { Container, RangeArea, ValuesArea, Value } from './styles';

interface DepartureTimes {
  sectorNumber: number;
  text: string;
  from: number;
  to: number;
}
interface Props {
  departureTimes: DepartureTimes[];
  values: DepartureTime[];
  onChange: (values: DepartureTime[]) => void;
  className?: string;
  isOpen?: boolean;
}

const DepartureTimes = ({ departureTimes, values, onChange, isOpen = false, className = '' }: Props) => {
  const { t } = useStoreTranslation();

  const handleDepartureTimeChange = (sectorNumber: number, rangeValue: number[], text: string) => {
    onChange([
      ...values.filter((item) => item.sectorNumber !== sectorNumber),
      {
        sectorNumber,
        from: moment.duration(rangeValue.first(), 'seconds').format('HH:mm:ss'),
        to: moment.duration(rangeValue.last(), 'seconds').format('HH:mm:ss'),
        text,
      },
    ]);
  };

  const renderDepatureTime = (sectorNumber: number, min: number, max: number, text: string, value?: DepartureTime) => {
    const minSeconds = moment.duration(min, 'hours').asSeconds();
    const maxSeconds = moment.duration(max, 'hours').asSeconds();

    return (
      <Container className={className}>
        <RangeArea>
          <Range
            step={60}
            min={minSeconds}
            max={maxSeconds}
            value={[
              value ? moment.duration(value.from).asSeconds() : minSeconds,
              value ? moment.duration(value.to).asSeconds() : maxSeconds,
            ]}
            onChange={(rangeValue) => handleDepartureTimeChange(sectorNumber, rangeValue, text)}
          />
        </RangeArea>
        <ValuesArea>
          <Value>
            {moment.duration(value ? value.from : minSeconds, 'seconds').format('HH[:]mm', { trim: false })}
          </Value>
          <Value>{moment.duration(value ? value.to : maxSeconds, 'seconds').format('HH[:]mm', { trim: false })}</Value>
        </ValuesArea>
      </Container>
    );
  };

  const isChanged = (departureTime: DepartureTimes, value?: DepartureTime): boolean => {
    if (!value) return false;
    return (
      moment.duration(departureTime.from, 'hours').format('HH:mm:ss') !== value?.from ||
      moment.duration(departureTime.to, 'hours').format('HH:mm:ss') !== value?.to
    );
  };

  return (
    <>
      {departureTimes.map((departureTime) => (
        <FilterItem
          key={departureTime.sectorNumber}
          name={t('flightsFilters.departureTimes.title', {
            trip: departureTime.text,
          })}
          changed={isChanged(
            departureTime,
            values.find((item) => item.sectorNumber === departureTime.sectorNumber),
          )}
          className={className}
          isOpen={isOpen}
        >
          {renderDepatureTime(
            departureTime.sectorNumber,
            departureTime.from,
            departureTime.to,
            departureTime.text,
            values.find((item) => item.sectorNumber === departureTime.sectorNumber),
          )}
        </FilterItem>
      ))}
    </>
  );
};

export default DepartureTimes;
